import { ref as p, watch as w, unref as m, getCurrentScope as g, onScopeDispose as b, onMounted as h, nextTick as v, getCurrentInstance as y } from "vue";
function I(e) {
  return g() ? (b(e), !0) : !1;
}
function l(e) {
  return typeof e == "function" ? e() : m(e);
}
const S = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const T = Object.prototype.toString, W = (e) => T.call(e) === "[object Object]", d = () => {
}, F = /* @__PURE__ */ O();
function O() {
  var e, n;
  return S && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function P(e, n) {
  function o(...t) {
    return new Promise((i, r) => {
      Promise.resolve(e(() => n.apply(this, t), { fn: n, thisArg: this, args: t })).then(i).catch(r);
    });
  }
  return o;
}
function j(e, n = {}) {
  let o, t, i = d;
  const r = (u) => {
    clearTimeout(u), i(), i = d;
  };
  return (u) => {
    const s = l(e), c = l(n.maxWait);
    return o && r(o), s <= 0 || c !== void 0 && c <= 0 ? (t && (r(t), t = null), Promise.resolve(u())) : new Promise((a, f) => {
      i = n.rejectOnCancel ? f : a, c && !t && (t = setTimeout(() => {
        o && r(o), t = null, a(u());
      }, c)), o = setTimeout(() => {
        t && r(t), t = null, a(u());
      }, s);
    });
  };
}
function x(e) {
  return y();
}
function C(e, n = 200, o = {}) {
  return P(
    j(n, o),
    e
  );
}
function M(e, n = 200, o = {}) {
  const t = p(e.value), i = C(() => {
    t.value = e.value;
  }, n, o);
  return w(e, () => i()), t;
}
function _(e, n = !0, o) {
  x() ? h(e, o) : n ? e() : v(e);
}
export {
  S as a,
  W as b,
  I as c,
  _ as d,
  F as i,
  d as n,
  M as r,
  l as t
};
//# sourceMappingURL=index-9FD4Wxfy.mjs.map
